import { createUserAppointment } from "./userAppointment";

import { IAppointmentListResponseDto } from "modules/user/application/types/IAppointmentListResponseDto";

export const createUserAppointments = (
  total: number = 10,
  limit: number = 8,
  offset: number = 0
): IAppointmentListResponseDto => {
  return {
    total: total,
    limit: limit,
    offset: offset,
    userAppointments: Array.from(
      Array(
        Math.floor((total - offset) / limit) > 0 ? limit : total - offset
      ).keys()
    ).map((key) => {
      const index = key + 1;
      return createUserAppointment({
        appointmentId: (offset + index).toString(),
      });
    }),
  };
};
